import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import BusinessImpact from "@/components/landing/BusinessImpact";
import AIFeatures from "@/components/landing/AIFeatures";
import Testimonials from "@/components/landing/Testimonials";
import FinalCTA from "@/components/landing/FinalCTA";
import Footer from "@/components/landing/Footer";

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-white" data-testid="landing-page">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <BusinessImpact />
        <AIFeatures />
        <Testimonials />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
